module.exports = __webpack_public_path__ + "static/media/chevron.98e6abb1.svg";